// 任务分解
import request from '@/utils/request'

const BaseUrl = '/bizTaskDecomposition'

// /bizTaskDecomposition/findList 查询列表
export function findList(params) {
  return request({
    url: `${BaseUrl}/findListV2`,
    method: 'get',
    params
  })
}
// 添加
export function save(data) {
  return request({
    url: `${BaseUrl}/saveV2`,
    method: 'post',
    data
  })
}

// 修改
export function update(data) {
  return request({
    url: `${BaseUrl}/updateV2`,
    method: 'put',
    data
  })
}

// 删除任务
export function delTask(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete'
  })
}

// /bizTaskDecomposition/getDisposablePerson 根据项目号查询可支配人员
export function getDisposablePerson(params) {
  return request({
    url: `${BaseUrl}/getDisposablePersonV2`,
    method: 'get',
    params
  })
}
// 任务确认单
export function taskVerify(data,id) {
  return request({
    url: `/taskVerify/${id}`,
    method: 'put',
    data
  })
}

// 任务确认单-退回
export function taskRefuse(data) {
  return request({
    url: `/taskVerify/refuseV2`,
    method: 'post',
    params: data
  })
}

// 任务确认单时选择项目角色
export function taskVerifySelectRoleUrl() {
  return "/taskVerifySelectRoleUrl"
}

// 项目进度批量分解
export function saveBath(data) {
  return request({
    url: `${BaseUrl}/saveBatch`,
    method: 'post',
    data
  })
}

// 根据项目节点查询任务列表
export function getByProjectNode(params) {
  return request({
    url: `${BaseUrl}/getByProjectNode`,
    method: 'get',
    params
  })
}